
import { useState, useEffect } from 'react';


import { usePinAuth } from '@/hooks/usePinAuth';
import { UserRole } from '@/types/profiles';

export const useUserRole = () => {
  const [userRole, setUserRole] = useState<UserRole | null>(null);
  const [loading, setLoading] = useState(true);

  const { pinUser, isAuthenticated: isPinAuthenticated } = usePinAuth();

  useEffect(() => {
    // Si l'utilisateur est authentifié via PIN, utiliser son rôle
    if (isPinAuthenticated && pinUser) {
      setUserRole({
        user_id: pinUser.id,
        role: pinUser.app_role,
        created_at: new Date().toISOString()
      } as UserRole);
      setLoading(false);
      return;
    }

    // Sinon, aucun utilisateur authentifié
    setUserRole(null);
    setLoading(false);
  }, [pinUser, isPinAuthenticated]);



  const hasRole = (role: 'employee' | 'manager' | 'admin'): boolean => {
    if (!userRole?.role) return false;
    
    // Normaliser le rôle pour la comparaison
    const normalizedRole = userRole.role.toLowerCase().trim();
    
    // Mapping des rôles PIN vers les rôles attendus
    if (normalizedRole === 'employe') return role === 'employee';
    if (normalizedRole === 'contremaitre') return role === 'manager';
    if (normalizedRole === 'manager') return role === 'manager';
    if (normalizedRole === 'admin') return role === 'admin';
    
    // Fallback vers la comparaison directe
    return normalizedRole === role;
  };

  const isManager = (): boolean => {
    return hasRole('manager') || hasRole('admin');
  };

  const isEmployee = (): boolean => {
    return hasRole('employee');
  };

  const isAdmin = (): boolean => {
    return hasRole('admin');
  };

  return {
    userRole,
    loading,
    hasRole,
    isManager,
    isEmployee,
    isAdmin,
  };
};
